import { QUERY_KEYS } from '../../../../../consts';
import { getAtomWithMutation, getQuoteProducts } from '../../../../../utils';

export const getQuoteProductsAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.QUOTES.QUOTE_PRODUCTS,
  mutationFn: () => getQuoteProducts,
});
